'use client';

import fork from '@haaretz/l-fork.macro';
import { hostname } from '@haaretz/s-consts';
import PPChangeAccountBanner from '@haaretz/s-pp-change-account-banner';
import PPFooter from '@haaretz/s-pp-footer';
import PPMasthead from '@haaretz/s-pp-masthead';
import getCurrentStepName from '@haaretz/s-pp-routing-utils/getCurrentStepName';
import { BiDataContextProvider } from '@haaretz/s-use-bi';
import PPDataStoreContextProvider from '@haaretz/s-use-pp-data-store';
import PPDataStepsContextProvider from '@haaretz/s-use-pp-offset-steps-store';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React from 'react';
import s9 from 'style9';

import PpPageSaver from './components/PpPageSaver';
import PpPageviewSender from './components/PpPageviewSender';
import PpSideEffects from './components/PpSideEffects';

const c = s9.create({
  wrapper: {
    minHeight: '100vh',
    display: 'grid',
    gridTemplateRows: 'auto 1fr auto',
  },
  layout: {
    display: 'grid',
    justifyContent: 'center',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'max-content',
  },
});

const title = fork({
  default: 'מינוי לאתר הארץ',
  tm: 'מינוי לאתר TheMarker – מינוי לדהמרקר',
  hdc: 'Haaretz Digital Subscriptions',
});

const description = fork({
  default:
    'רכשו מינוי לאתר הארץ וקבלו את כל תכני הארץ במחשב ובאפליקציה, פחות פרסומות, פודקאסט שבועי ועדכונים שוטפים לכל מכשיר שתרצו.',
  tm: 'מינוי לאתר TheMarker: רכשו מינוי לדהמרקר וקבלו את כל תכני דהמרקר במחשב ובאפליקציה, פחות פרסומות, ניוזלטרים, פודקאסטים שבועיים ועדכונים שוטפים לכל מכשיר שתרצו',
  hdc: "Haaretz digital subscriptions: Get the most reliable reporting on Israel, the Middle East and the Jewish world. Subscribe now to Israel's leading newspaper.",
});

const groupSubTitle = fork({
  default: 'מינוי ארגוני לאתר הארץ',
  tm: 'מינוי ארגוני לאתר TheMarker - מינוי לדהמרקר',
  hdc: 'Organizational Subscription to Haaretz',
});

const groupSubDesc = fork({
  default: 'הצעה מיוחדת לחברות, ארגונים, בתי ספר ומוסדות חינוכיים - גישה מלאה לתכני הארץ',
  tm: 'הצעה מיוחדת לחברות, ארגונים, בתי ספר ומוסדות חינוכיים - גישה מלאה לתכני TheMarker',
  hdc: 'Special offer to companies, organizations, schools and academic institutions - get full access to Haaretz',
});

export default function PurchasePageLayout({ children }: React.PropsWithChildren<unknown>) {
  const router = useRouter();
  const currentStepName = getCurrentStepName(router.pathname);
  const isGroupSub = currentStepName === 'groupSubscription';

  return (
    <>
      <PpSideEffects />
      <Head>
        <title>{isGroupSub ? groupSubTitle : title}</title>
        <meta name="description" content={isGroupSub ? groupSubDesc : description} />
        <link rel="canonical" href={`https://promotion.${hostname}/`} />
      </Head>
      <div className={s9(c.wrapper)}>
        <PPDataStoreContextProvider>
          <PPDataStepsContextProvider>
            <PpPageSaver />
            <BiDataContextProvider>
              <PpPageviewSender />
              <PPMasthead />
              <main className={s9(c.layout)}>
                <PPChangeAccountBanner />
                {children}
              </main>
              <PPFooter />
            </BiDataContextProvider>
          </PPDataStepsContextProvider>
        </PPDataStoreContextProvider>
      </div>
    </>
  );
}
